import { LinearProgress } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import useApi from "../../../../hooks/api";
import { Alert } from "../../../ui";
import { CrmContext } from "../context";
import CrmPhase from "../phase";
import CrmTradeDetails from "../trade/details";
import "./board.css.scss";

export default function CrmBoard({ newTradeId }) {
  const context = useContext(CrmContext);
  const { get } = useApi();

  const [error, setError] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [phases, setPhases] = useState(undefined);

  useEffect(() => {
    setLoading(true);

    get("/v1/crm/phases")
      .then((response) => {
        setPhases(response.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, [context.tradeId]);

  return context.tradeId ? (
    <CrmTradeDetails />
  ) : (
    <div className="crm-board">
      {loading && (
        <div className="q-progress w-100">
          <LinearProgress />
        </div>
      )}

      {error && (
        <Alert
          severity="error"
          title="ATENÇÃO!"
          message="Ocorreu um erro ao carregar a lista de negociações. Se o problema persistir, entre em contato conosco."
        />
      )}

      {phases &&
        phases.map((phase, i) => (
          <CrmPhase key={i} newTradeId={newTradeId} {...phase} />
        ))}
    </div>
  );
}
